// What a cell of BasePhoneTable holds: the page's template for its column (VNodes), or the
// value itself.
export default {
  name: 'PhoneTableCell',
  functional: true,
  props: {
    nodes: {
      type: [Array, Object, String, Number, Boolean],
      default: null,
    },
  },
  render(h, { props }) {
    if (props.nodes !== null && typeof props.nodes === 'object') return props.nodes;
    return h('span', props.nodes == null ? '' : String(props.nodes));
  },
};
